export default dataDeviceInfo = {
    loading: true,
    ipAddress: '',

    async fetchIpAddress() {
        this.loading = true;
        try {
            const response = await fetch('https://api.ipify.org?format=json');
            const data = await response.json();
            this.ipAddress = data.ip;
        } catch (error) {
            this.ipAddress = 'Error fetching IP';
        } finally {
            this.loading = false;
        }
    }
};